// The identity card of the Log Job page — heading, customer name, address and
// (optional) context pills — extracted from LogJob.js unchanged so the
// unscheduled-visit Reason step's rail (KAN-771) draws the SAME card Log Job's
// rail shows on step 3. `action` (e.g. a quiet "Change" link) sits in the card's
// top-right on the wide layout; omitted, the markup is exactly what LogJob
// rendered inline before.
import { MapPin } from 'lucide-react';
import { styles } from './logJobStyles';

/**
 * Height of the "Logged by" block under the address on the wide rail: the
 * pills row's 10px top margin + the attribution dropdown's trigger (the taller
 * of its two shapes; the static byline is shorter). The unscheduled-visit flow
 * reserves exactly this on BOTH the Reason step's card and Log Job's card
 * (`reservePills`), so the card is the same height on both screens whichever
 * shape the row ends up taking (KAN-771).
 */
export const LOGJOB_IDENTITY_PILLS_MIN_HEIGHT = 40;

export default function LogJobIdentityCard({ heading, name, address, pills = null, isMobile = false, action = null, reservePills = false, testId }) {
  return (
    <div style={{ ...styles.heroCard, ...(isMobile ? styles.heroCardMobile : {}) }} data-testid={testId}>
      <div>
        <h2 style={{ ...styles.title, ...(isMobile ? styles.titleMobile : {}) }}>{heading}</h2>
        <div style={{ ...styles.customerName, ...(isMobile ? styles.customerNameMobile : {}) }}>{name}</div>
        <p style={{ ...styles.address, ...(isMobile ? styles.addressMobile : {}), display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
          <MapPin size={14} strokeWidth={2} aria-hidden /> {address}
        </p>
        {reservePills ? (
          <div style={{ display: 'flow-root', minHeight: LOGJOB_IDENTITY_PILLS_MIN_HEIGHT }} data-testid="logjob-identity-pills">{pills}</div>
        ) : pills}
      </div>
      {action}
    </div>
  );
}
